import { Component, EventEmitter, Input, Output } from '@angular/core'
import { IconComponent } from '@ftr/foundation'
import { AccountDropdownComponent } from '~app/core/account-dropdown/account-dropdown.component'

@Component({
  selector: 'ftr-top-bar-display',
  templateUrl: './top-bar-display.component.html',
  styleUrls: ['./top-bar-display.component.css'],
  standalone: true,
  imports: [AccountDropdownComponent, IconComponent],
})
export class TopBarDisplayComponent {
  @Input() sideBarOpened: boolean
  @Output() sideBarToggled = new EventEmitter<void>()

  toggleSideBar(): void {
    this.sideBarToggled.emit()
  }
}
